var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 908.54 401.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,365.43c50.39-21.78,69.88-112.73,262.53-130.84,149.81-14.08,206.27-23.38,226.96-137.72,19.1-105.54,199.81-138.63,311.59-26.44,42.8,42.95,105.24,89.54,107.01,88.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.15,383.26c46.85-20.04,64.8-104.16,244.07-120.49,102.86-9.37,149.48-8.72,190.98-47.32,20.83-19.38,35-82.31,43.6-114.28,15.44-57.4,89.08-81.04,143.05-65.8,53.55,15.12,76.61,22.55,117.92,75.3,37.71,48.15,103.28,87.78,105.18,83.48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.17,401.12c43.11-17.7,58.98-93.5,224.42-106.76,128.65-10.31,220.74-25.51,226.6-123.42,8.03-134.02,130.48-147.79,234.78-8.51,29.31,39.14,91.33,75.82,92.85,74.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines2);
export default __webpack_public_path__ + "static/media/lines_2.0fe2dc24c238114ae3e1f0ef2b9effdb.svg";
export { ForwardRef as ReactComponent };